import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import CommunityApi from "../../../api/community.api";
import DelBtn from "../../../component/atoms/button/delBtn";
import DetailBtn from "../../../component/atoms/button/detailBtn";
import EditBtn from "../../../component/atoms/button/editBtn";
import TableDelBtn from "../../../component/atoms/button/tableDelBtn";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Table from "../../../component/atoms/layout/table/table";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import TableText from "../../../component/atoms/text/table/tableText";
import GoBack from "../../../component/molecules/goBack";
import Pagination from "../../../component/molecules/pagination";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import CommunityCommentModal from "../_component/communityCommentModal";
import MoveModal from "../_component/moveModal";

const CommunityPostDetail = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [communityInfo, setCommunityInfo] = useState({});
  const [commentList, setCommentList] = useState([]);

  useEffect(() => {
    getCommunityInfo();
    getComment();
  }, [location]);

  const getCommunityInfo = async () => {
    try {
      const response = (await CommunityApi.getPostById(id)).data.data.content;
      setCommunityInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
  });

  const getComment = async () => {
    try {
      const data = {
        communityPostId: id,
        page: searchParams.get("page"),
        size: pagination.size,
      };

      const response = (await CommunityApi.getComment(data)).data.data;

      setCommentList(response.content);
      setPagination({
        ...pagination,
        totalCount: response.totalCount ? response.totalCount : 0,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 삭제
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      const data = {
        ids: [id],
      };
      await CommunityApi.delPost(data);
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ----- 댓글 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [commentDeleteModalOpen, setCommentDeleteModalOpen] = useState(false);

  const commentDeleteFunc = async () => {
    try {
      const data = {
        ids: delIdList,
      };
      await CommunityApi.delComment(data);
      toast(toastMsg.delete);
      setCommentDeleteModalOpen(false);
      setDelIdList([]);
      getComment();
    } catch (error) {
      errorHandler(error);
    }
  };

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [moveModalOpen, setMoveModalOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <DelBtn onClick={() => setDeleteModalOpen(true)} />
              <EditBtn
                text={"이동하기"}
                onClick={() => {
                  setMoveModalOpen(true);
                }}
              />
            </div>
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>상세보기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>작성일</DetailFormTitle>
                <DetailFormText>
                  {moment.utc(communityInfo.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>조회수</DetailFormTitle>
                <DetailFormText>{communityInfo.viewCount}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <DetailFormText>{communityInfo.member?.account}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <DetailFormText>{communityInfo.member?.name}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>닉네임</DetailFormTitle>
                <DetailFormText>
                  {communityInfo.member?.nickname}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리</DetailFormTitle>
                <DetailFormText>
                  {communityInfo.communityCategory?.title}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>제목</DetailFormTitle>
                <DetailFormText>{communityInfo.title}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>내용</DetailFormTitle>
                <DetailFormText>{communityInfo.content}</DetailFormText>
              </DetailPageForm>
            </div>
          </DetailPage>

          <DetailPage>
            <DetailPageTitle>댓글 관리</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <Table
                style={{
                  width: 964,
                }}
              >
                <colgroup>
                  {/* 날짜/시간 */}
                  <col width="227px" />
                  {/* 아이디 */}
                  <col width="93px" />
                  {/* 내용 */}
                  <col width="424px" />
                  {/* 삭제하기 */}
                  <col width="79px" />
                  {/* 상세보기 */}
                  <col width="76px" />
                </colgroup>
                <thead>
                  <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                    <Th
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      <TableText>날짜/시간</TableText>
                    </Th>
                    <Th>
                      <TableText>아이디</TableText>
                    </Th>
                    <Th>
                      <TableText>내용</TableText>
                    </Th>
                    <Th>
                      <TableText>삭제하기</TableText>
                    </Th>
                    <Th>
                      <TableText>상세보기</TableText>
                    </Th>
                  </Tr>
                </thead>
                <tbody>
                  {commentList.map((item, index) => {
                    return (
                      <Tr
                        key={index}
                        style={{ height: "59px", background: "#fff" }}
                      >
                        <Td
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <TableText>
                            {moment(item.createdAt).format(
                              "YYYY/MM/DD HH:mm:ss"
                            )}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText
                            style={{
                              width: "80px",
                            }}
                          >
                            {item.member?.account}
                          </TableText>
                        </Td>
                        <Td>
                          <TableText
                            style={{
                              width: "400px",
                            }}
                          >
                            {item.content}
                          </TableText>
                        </Td>
                        <Td>
                          <TableDelBtn
                            onClick={() => {
                              const delList = [item];
                              setDelIdList(delList.map((item) => item.id));
                              setCommentDeleteModalOpen(true);
                            }}
                          />
                        </Td>
                        <Td>
                          <DetailBtn
                            onClick={() => {
                              setSelectedData(item);
                              setDetailModalOpen(true);
                            }}
                          />
                        </Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
              <Pagination
                style={{
                  width: 964,
                }}
                route={route.community_post_detail + `/${id}`}
                queryString={""}
                currentPage={page}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {commentDeleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setCommentDeleteModalOpen}
          onClick={() => {
            commentDeleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? (
        <CommunityCommentModal
          data={selectedData}
          setModalOpen={setDetailModalOpen}
        />
      ) : (
        ""
      )}

      {moveModalOpen ? (
        <MoveModal
          setModalOpen={setMoveModalOpen}
          currentCategory={communityInfo.communityCategory?.title}
          currentCategoryId={communityInfo.communityCategory?.id}
          id={id}
          onMoved={getCommunityInfo}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CommunityPostDetail;
